// HomePageLayout.js
import React from 'react';
import ReserveForm from '../components/ReserveForm';
import { useTranslation } from 'react-i18next';

const HomePageLayout = () => {
  const [t, i18n] = useTranslation("global");
  return (
    <div id='locations' className='container mx-auto relative items-center text-center'>
      {/* Responsive layout using Flexbox */}
      <h1 className='font-primary text-[45px] my-4 pt-12 mx-auto tracking-wide justify-center'>{t(`navBarT.locations`)}</h1>

      <div className='flex flex-col lg:flex-row gap-8 pt-12'>
        
        {/* Left column */}
        <div className='flex flex-col lg:w-1/2'>
          {/* First section with title and map */}
          <div className='mb-4'>
            <h2 className='text-2xl font-tertiary mb-2 tracking-wide'>Dream Apartment</h2>
            <p className='mt-2 mb-4'>Adi Endrea 30</p>
            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2809.3183257083447!2d19.807997376092096!3d45.24135537107126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475b102c2999fb27%3A0x9ba112aea55209f5!2sAdi%20Endrea%2030%2C%20Novi%20Sad%20406331%2C%20Serbia!5e0!3m2!1sen!2smk!4v1704808017346!5m2!1sen!2smk'
              width='100%'
              height='285'
              style={{ border: 0 }}
              allowFullScreen=''
              loading='lazy'
              referrerPolicy='no-referrer-when-downgrade'
              title='Location 1 Map'
            ></iframe>
          </div>
          {/* <hr className="my-4 w-3/4 mx-auto border-black" /> */}
          {/* Second section with title and map */}
          
        </div>
        {/* Right column */}
        <div className='lg:w-1/2'>
          {/* <ReserveForm apartmentName='Main Page' /> */}
          <div>
            <h2 className='text-2xl font-tertiary mb-2 tracking-wide'>DC Executive Homes</h2>
            <p className='mt-2 mb-4'>Milutina Bojića 12</p>
            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2809.237513835913!2d19.815624676092128!3d45.242989671071236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475b1030033b0da9%3A0x60aa57c31ecadfa!2sMilutina%20Boji%C4%87a%2012%2C%20Novi%20Sad%20406022%2C%20Serbia!5e0!3m2!1sen!2smk!4v1704808809912!5m2!1sen!2smk'
              width='100%'
              height='285'
              style={{ border: 0 }}
              allowFullScreen=''
              loading='lazy'
              referrerPolicy='no-referrer-when-downgrade'
              title='Location 2 Map'
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageLayout;
